import React from 'react';
import PropTypes from 'prop-types';
import { Document, Page, View, Text, StyleSheet, Image } from '@react-pdf/renderer';
import DefaultLogo from "../../../../static/img/defaultImages/Account.png";

const FOOTER_HEIGHT = 10;

const styles = StyleSheet.create({

    row: { flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', },
    column: { flexDirection: 'column' },
    header: {
        fontSize: 11,
        marginBottom: 5
    },
    header2: {
        fontSize: 11,
        marginBottom: 2
    },
    logo: { width: 70, height: 70, objectFit: "contain" },
    sectionTitle: {
        fontSize: 10,
        marginBottom: 2
    },
    table: { marginTop: 10, }, //   borderRadius: 12, overflow: 'hidden',
    tableRow: { flexDirection: 'row', marginTop: 5 },
    // tableHeader: {
    //     flexDirection: 'row',
    //     borderBottomWidth: 1,
    //     borderBottomColor: '#656565',
    //     borderStyle: 'solid',
    // },
    // tableCell: {
    //     flex: 1,
    //     padding: 4,
    //     fontSize: 10,
    //     marginBottom: 5,
    // },
    // tableCell2: {
    //     flex: 1,
    //     padding: 4,
    //     fontSize: 10,
    //     color: '#656565',
    //     marginBottom: 5,
    // },
    tableCell3: {
        flex: 1,
        padding: 4,
        fontSize: 10,
        color: '#656565',
    },
    tableLastRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#656565',
        borderStyle: 'solid',
        marginBottom: 5,
        marginTop: 5,
    },
    rightAlign: {
        textAlign: 'right',
        // alignSelf: 'flex-end',
    },
    totalSection: { marginTop: 10, alignSelf: 'flex-end', width: '50%' },
    textBold: {
        fontSize: 10
    },
    textBold2: {
        fontSize: 10,
        color: "#656565",
        marginBottom: 2,
        wordBreak: 'break-word',  // ✅ wrap long words
        flexWrap: 'wrap',         // ✅ wrap inside text element
        maxWidth: '95%',
    },

    page: {
        paddingTop: 10,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: FOOTER_HEIGHT + 50, // reserve space
        fontSize: 9,
    },

    body: {
        flexGrow: 1,
    },

    footer: {
        position: "absolute",
        bottom: 20,
        left: 20,
        right: 20,
        height: FOOTER_HEIGHT,
        // borderTopWidth: 1,
        // borderTopColor: "#656565",
        paddingTop: 50,
        justifyContent: 'center',
        alignItems: 'center',
    },

    footerText: {
        textAlign: "center",
        fontSize: 8,
        color: "#656565",
    },
    addressBox: {
        backgroundColor: '#ebf7ff',
        padding: 5,
        borderRadius: 4,
        // minHeight: 120,
        borderWidth: 1,
        borderColor: '#f1f1f1',
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#407fe9',
        color: '#ffffff',
        borderBottomWidth: 0.5,
        borderBottomColor: '#ebf7ff',
        borderStyle: 'solid',
        borderTopLeftRadius: 12,
        borderTopRightRadius: 12,
    },

    tableRowOdd: {
        flexDirection: 'row',
        marginTop: 0,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        backgroundColor: '#ebf7ff',
        borderLeftColor: '#ebf7ff',
        borderRightColor: '#ebf7ff',
    },

    tableRowEven: {
        flexDirection: 'row',
        marginTop: 0,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        backgroundColor: '#ffffff',
        borderLeftColor: '#ebf7ff',
        borderRightColor: '#ebf7ff',
    },
    tableCell: {
        flex: 1,
        paddingVertical: 8,
        paddingHorizontal: 6,
        fontSize: 10,
        fontWeight: 600,
    },

    tableCell2: {
        flex: 1,
        paddingVertical: 8,
        paddingHorizontal: 6,
        fontSize: 10,
        color: '#444',
    },
    tableLastRowRadius: {
        borderBottomLeftRadius: 12,
        borderBottomRightRadius: 12,
        borderBottomWidth: 0.5,
        borderBottomColor: '#d6eefc',
        borderStyle: 'solid',
    },
});

const InvoicePDF = ({ data, companyData, tableItem, tableColum, currencySettings, Calculation }) => (
    <Document>
        <Page size="A4" style={styles.page}>
            {/* Footer - fixed on all pages */}
            <View style={styles.footer} fixed>
                {/* <Text style={styles.footerText}>
                    Thank you for your business! - {companyData?.companyName}
                </Text> */}
            </View>

            <View style={styles.body}>
                {/* HEADER */}
                <View style={[styles.row, { borderBottomWidth: 1, borderBottomColor: '#656565', borderStyle: 'solid' }]}>
                    <View>
                        <Text style={styles.header}>{companyData?.companyName}</Text>
                        <Text style={styles.textBold2}>{companyData?.street}</Text>
                        <Text style={styles.textBold2}>{companyData?.city}</Text>
                        <Text style={styles.textBold2}>{companyData?.state} {companyData?.zipcode}</Text>
                        <Text style={styles.textBold2}>{companyData?.country}</Text>
                        <Text style={{
                            fontSize: 14,
                            marginTop: 10, marginBottom: 10
                        }}>Quote</Text>
                    </View>
                    <View>
                        <Image style={styles.logo} src={companyData?.accountLogo || DefaultLogo} />
                    </View>
                </View>

                {/* BILL TO / SHIP TO */}
                <View style={[styles.row, { marginTop: 20, marginBottom: 10 }]}>
                    <View style={{ width: '33%', paddingRight: 20 }}>
                        <View style={styles.addressBox}>
                            <Text style={styles.header}>Bill To</Text>
                            <Text style={styles.textBold2}>{data?.billingAddress?.name}</Text>
                            <Text style={styles.textBold2}>{data?.billingAddress?.street}</Text>
                            <Text style={styles.textBold2}>{data?.billingAddress?.city}</Text>
                            <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.billingAddress?.state} {data?.billingAddress?.zipcode}</Text>
                            <Text style={styles.textBold2}>Email: {data?.billingAddress?.email}</Text>
                            <Text style={styles.textBold2}>Mobile: {data?.billingAddress?.mobile}</Text>
                        </View>
                    </View>
                    <View style={{ width: '33%', paddingRight: 20 }}>
                        <View style={styles.addressBox}>
                            <Text style={styles.header}>Ship To</Text>
                            <Text style={styles.textBold2}>{data?.shippingAddress?.name}</Text>
                            <Text style={styles.textBold2}>{data?.shippingAddress?.street}</Text>
                            <Text style={styles.textBold2}>{data?.shippingAddress?.city}</Text>
                            <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.shippingAddress?.state} {data?.shippingAddress?.zipcode}</Text>
                            <Text style={styles.textBold2}>Email: {data?.shippingAddress?.email}</Text>
                            <Text style={styles.textBold2}>Mobile: {data?.shippingAddress?.mobile}</Text>
                        </View>
                    </View>
                    <View style={{ flex: 1, alignItems: 'flex-end' }}>
                        <Text style={styles.header2}>Quote Number</Text>
                        <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.quotesNumber}</Text>
                        {/* <Text style={styles.header2}>Account Name</Text>
                        <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.accountName} ({data?.accountNumber})</Text> */}
                        <Text style={styles.header2}>Issue Date</Text>
                        <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.issueDate}</Text>
                        {/* <Text style={styles.header2}>Service Description</Text>
                        <Text style={[styles.textBold2, { marginBottom: 5 }]}>{data?.dealName}</Text> */}
                        <Text style={styles.header2}>Expiry Date</Text>
                        <Text style={styles.textBold2}>{data?.validUntil}</Text>
                    </View>
                </View>

                {/* TABLE */}
                <View style={styles.table}>
                    <View style={styles.tableHeader}>
                        {tableColum?.map((col, colIndex) => (
                            <Text style={[styles.tableCell, colIndex === tableColum.length - 1 && styles.rightAlign]} key={col.key}>
                                {typeof col.title === 'object' ? col.title.props.children : col.title}
                            </Text>
                        ))}
                    </View>
                    {tableItem?.map((item, index) => (
                        <View
                            key={index}
                            style={[
                                index % 2 === 0
                                    ? styles.tableRowOdd
                                    : styles.tableRowEven,

                                index === tableItem.length - 1 &&
                                styles.tableLastRowRadius
                            ]}
                        >
                            {/* // <View style={index === tableItem.length - 1 ? styles.tableLastRow : styles.tableRow} key={index}> */}
                            {tableColum?.map((col, colIndex) => (
                                <Text style={[
                                    styles.tableCell2,
                                    colIndex === tableColum.length - 1 && styles.rightAlign
                                ]} key={col.key}>
                                    {col.key === "duration"
                                        ? item[col.key]
                                            ? item.productCategory !== "Software"
                                                ? "One off"
                                                : `${item[col.key]} Month(s)`
                                            : "-"
                                        :  ["total", "price", "amount", "subtotal"].includes(col.key)
                                            ? Number(item[col.key] || 0).toLocaleString()
                                            : item[col.key] || "-"}
                                </Text>
                            ))}
                        </View>
                    ))}

                    {/* Totals */}
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, textAlign: 'right' }]}>Subtotal</Text>
                        <Text style={[styles.tableCell3, { flex: 2, textAlign: 'right' }]}>{currencySettings?.currency} {Number(Calculation?.total)?.toLocaleString()}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, textAlign: 'right' }]}>Discount</Text>
                        <Text style={[styles.tableCell3, { flex: 2, textAlign: 'right' }]}>{Calculation?.dealDiscount} %</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, textAlign: 'right' }]}>Tax</Text>
                        <Text style={[styles.tableCell3, { flex: 2, textAlign: 'right' }]}>{Calculation?.tax} %</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, textAlign: 'right' }]}>Adjustment</Text>
                        <Text style={[styles.tableCell3, { flex: 2, textAlign: 'right' }]}>{currencySettings?.currency} {Number(Calculation?.adjustment)?.toLocaleString()}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, textAlign: 'right' }]}>Shipping/Handling</Text>
                        <Text style={[styles.tableCell3, { flex: 2, textAlign: 'right' }]}>{currencySettings?.currency} {Number(Calculation?.shippingss)?.toLocaleString()}</Text>
                    </View>
                    <View style={styles.tableRow}>
                        <Text style={[styles.tableCell3, { flex: tableColum.length - 2, fontSize: 12, color: "black", textAlign: 'right' }]}>Grand Total</Text>
                        <Text style={[styles.tableCell3, { flex: 2, fontSize: 12, color: "black", textAlign: 'right' }]}>{currencySettings?.currency} {Number(Calculation?.grandTotal)?.toLocaleString()}</Text>
                    </View>
                </View>

                {/* Terms */}
                <View style={[styles.row, { marginTop: 40 }]}>
                    <View>
                        <Text style={styles.header}>Terms and Conditions</Text>
                        <Text style={styles.textBold2}>{data?.termsAndCondition}</Text>
                    </View>
                </View>

            </View>
        </Page>
    </Document>
);

InvoicePDF.propTypes = {
    data: PropTypes.object.isRequired,
    companyData: PropTypes.object.isRequired,
    tableItem: PropTypes.array.isRequired,
    tableColum: PropTypes.array.isRequired,
    currencySettings: PropTypes.object.isRequired,
    Calculation: PropTypes.object.isRequired,
};

export default InvoicePDF;
